import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'flex',
    },
    fullWidthContainer: { display: 'flex', flexWrap: 'wrap', width: '100%' },
    containerPadding: { padding: '10px 25px 20px 0px' },
    rowPadding: { paddingRight: 25 },
    messageDetailRowPadding: { paddingRight: 25, paddingTop: 60 },
  };
});
